module.exports = __webpack_public_path__ + "static/img/404.6b8ae1d0.gif";